import React from 'react';
import PropTypes from 'prop-types';
import { IncrementDecrement, IncrementDecrementInner } from './NumberPillInput.styles';

const NumberPillInput = (props) => {
  const decrement = () => {
    const quantity = props.qty - props.step;
    if (quantity >= props.min) {
      props.onChange(quantity);
    }
  };

  const increment = () => {
    const quantity = props.qty + props.step;
    if (quantity <= props.max) {
      props.onChange(quantity);
    }
  };

  return (
    <IncrementDecrement>
      <IncrementDecrementInner>
        <label className="padding-horizontal float-left cursor item" onClick={decrement}>
          -
        </label>
        <label className="padding-horizontal quantity">{props.qty}</label>
        <label className="padding-horizontal float-right cursor item" onClick={increment}>
          +
        </label>
      </IncrementDecrementInner>
    </IncrementDecrement>
  );
};

NumberPillInput.propTypes = {
  qty: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
};

NumberPillInput.defaultProps = {
  onChange: () => {},
  max: Infinity,
  min: 0,
  step: 1,
};

export default NumberPillInput;
